import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
	public email: string;
	public sid: string;
	public unsubscribeComplete: boolean = false;

	constructor(private route: ActivatedRoute, private dataService: DataService) {}

	ngOnInit(): void {
		this.email = this.route.snapshot.paramMap.get("email");
		this.sid = this.route.snapshot.paramMap.get("sid");
	}

	unsubscribe() {
		this.dataService.unsubscribe(this.email, this.sid).subscribe((res) => {
			this.unsubscribeComplete = true;
		});
	}
}
